var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProjectType = function SvgProjectType(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CFCFCF",
    d: "M0 0h43v43H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#project_type_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-415-1266h1440V861H-415z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    fill: "#F2FAF1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.121 12.38v6.79h2.249a2.262 2.262 0 0 1 2.248 2.263v7.921a2.263 2.263 0 0 1-2.248 2.264h-4.497c-.618 0-1.124-.51-1.124-1.132V25.96h-4.497v4.526c0 .622-.506 1.132-1.124 1.132H13.63a2.263 2.263 0 0 1-2.248-2.264V16.907a2.262 2.262 0 0 1 2.248-2.263h2.248V12.38a2.262 2.262 0 0 1 2.249-2.263h6.745a2.262 2.262 0 0 1 2.248 2.263Zm-13.49 11.317h2.249v-2.264H13.63v2.264Zm2.249 4.522H13.63v-2.263h2.249v2.263Zm11.239 0h2.248v-2.263H27.12v2.263Zm-11.24-9.049h-2.248v-2.263h2.249v2.263Zm2.249 4.527h2.248v-2.264h-2.248v2.264Zm2.248-4.527h-2.248v-2.263h2.248v2.263Zm-2.248-4.526h2.248V12.38h-2.248v2.264Zm6.745 9.053h-2.248v-2.264h2.248v2.264Zm-2.248-4.527h2.248v-2.263h-2.248v2.263Zm2.248-4.526h-2.248V12.38h2.248v2.264Zm2.248 9.053h2.249v-2.264h-2.248v2.264Z",
    fill: "#58B847"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "project_type_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(-415 -1266)",
    d: "M0 0h1440v2127H0z"
  })))));
};
export default SvgProjectType;